import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
  //系统配置参数（默认国家等）
  systemDefaultParam:{},
  device:'wap',//wap、ios、android
  browse:'general',//general,dd,wx
  userType:null, //当前登录人员type,0为非内部人员（供应商），1为内部人员
  token:null, //用户token
  userId:null, //用户id
  supplierId:null, //若用户为供应商，全局存供应商id
  systemConfig: {}, // 系统预设
  iframeUrl:'',
  userData: '',
};
const getters = {};
const mutations = {
  changeSystemParam(state,obj){
    state.systemDefaultParam = obj;
  },
  changeSystemConfig(state,obj){
    state.systemConfig = obj;
  },
  changeDevice(state,str){
    state.device = str;
  },
  changeBrowse(state,str){
    state.browse = str;
  },
  changeUserType(state,str){
    state.userType = str;
  },
  changeToken(state,str){
    state.token = str;
  },
  changeUserId(state,id){
    state.userId = id;
  },
  changeSupplierId(state,supId){
    state.supplierId = supId;
  },
  changeIframeUrl(state,url){
    state.iframeUrl = url;
  },
  changePerson(state,name){
    state.userData = name;
  },
};
const actions = {
  commitChangeSystemParam(context,obj){
    context.commit('changeSystemParam',obj)
  },
  commitChangeSystemConfig(context,obj){
    context.commit('changeSystemConfig',obj)
  },
  commitChangeDevice(context,str){
    context.commit('changeDevice',str);
  },
  commitChangeBrowse(context,str){
    context.commit('changeBrowse',str);
  },
  commitChangeType(context,str){
    context.commit('changeUserType',str);
  },
  commitChangeToken(context,str){
    context.commit('changeToken',str);
  },
  commitChangeUserId(context,id){
    context.commit('changeUserId',id);
  },
  commitChangeSupId(context,id){
    context.commit('changeSupplierId',id);
  },
  commitChangeIframeUrl(context,url){
    context.commit('changeIframeUrl',url);
  },
  commitChangePerson(context,name){
    context.commit('changePerson',name);
  }
};
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js